angular.module 'app'
.controller 'ArticleListController', ($window, $timeout, $scope, $http, $state, $stateParams, $ionicPopup, config, activeUser, ionicMaterialInk) ->
  $scope.ui =
    load_show: false
    baseUrl: config.api.baseUrl
    homepage: activeUser.homepage
    title: ''
    userInfo: activeUser.user
    column: {}
    count: 0
    articles: []

  do findColumn = ->
    $http.get "#{config.api.baseUrl}/cumpus/programa/#{$stateParams.column_id}", {}
    .then (res) ->
      $scope.ui.column = res.data
      $scope.ui.title = $scope.ui.column.programa_name
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統錯誤！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )

  findArticles = ->
    $http.get "#{config.api.baseUrl}/cumpus/programa/list",
      params:
        is_show: true
        programa_id: $stateParams.column_id
        group_id: activeUser.group_id
        sort: '-release_time'
        end_release_time: String moment().add('d', 1)
        offset: $scope.ui.articles.length
        limit: 8
    .then (res) ->
      articles = res.data.data
      _.each articles, (val) ->
        val.release_time = moment(val.release_time).format 'YYYY-MM-DD'
      $scope.ui.articles = $scope.ui.articles.concat articles
      $scope.ui.count = res.data.count

      if $scope.ui.articles.length is $scope.ui.count
        $scope.ui.load_show = true
      $scope.$broadcast('scroll.infiniteScrollComplete')
      $timeout (->
        ionicMaterialInk.displayEffect()
      ), 1000
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統錯誤！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )

  $scope.findArticles = findArticles

  $scope.toOpen = (link) ->
    $window.open(link)

